<template>

  <div>
    <div class="pb-2">
      <label v-if="label"
             style="font-weight: bold;">{{ label }}</label>
    </div>
    <v-list class="pa-0 emails-input-list">
      <v-list-item
          v-for="(wrapper, index) in emailWrappers"
          :key="index"
          class="pl-0 "
          style="min-height: unset">
        <v-list-item-content class="pa-0 ">
          <v-list-item-title>
            <v-text-field v-model="wrapper.email"
                          ref="email"
                          dense
                          outlined
                          hide-details="auto"
                          class="mt-1 mb-1"
                          :placeholder="inputPlaceholder"
                          validate-on-blur
                          :rules="[buildRequiredValidator(), buildEmailValidator(), buildMaxLengthValidator(256)]"
                          @blur="changed"/>

          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action class="ma-0">
          <v-btn
              @click="remove(wrapper)"
              icon
              :title="$t('actions.delete')">
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-btn small
           @click="add"
           class="mt-1">
      <span>{{ $t('actions.add') }}</span>
    </v-btn>
  </div>
</template>

<script>
import { buildRequiredValidator, buildEmailValidator, buildMaxLengthValidator } from '@/utils/ValidatorBuilders';

export default {
  name: 'MultipleEmailsInput',
  components: {},
  props: {
    value: {
      required: true,
      type: Array,
    },
    label: {
      required: false,
      type: String,
    },
    inputPlaceholder: {
      required: false,
      type: String,
    },
  },
  computed: {
    emailWrappers: {
      get() {
        return this.value.map(email => {
          return { email: email };
        });
      },
      set(val) {
        val = val.map(wrapper => wrapper.email);

        this.$emit('input', val);
        this.$emit('change', val);
      },
    },
  },

  methods: {
    buildRequiredValidator,
    buildEmailValidator,
    buildMaxLengthValidator,

    add() {
      this.emailWrappers = [...this.emailWrappers, { email: '' }];
      this.$nextTick(() => {
        const indexOfLast = this.emailWrappers.length -1;
        this.$refs.email[indexOfLast].focus();
      });
    },

    remove(wrapperToRemove) {
      this.emailWrappers = this.emailWrappers.filter(wrapper => wrapper !== wrapperToRemove);
    },

    changed() {
      this.emailWrappers = [...this.emailWrappers];
    },
  },
};
</script>

<style></style>
